<template>
  <div class="stamp-item" aria-hidden="true">
    <img :src="icon" alt="" />
    <span class="stamp-item-num" v-if="showValue"> {{ value }} </span>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { STAMP_ICON_CONF } from '@/config';

export default defineComponent({
  name: 'StampItem',
  props: {
    icon: {
      type: String,
      default: STAMP_ICON_CONF.default,
    },
    value: {
      required: false,
      type: Number,
      default: 0,
    },
    showValue: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="less" scoped>
@import '~@/less/main';
.stamp-item {
  position: relative;
  img {
    width: 90 / @rem;
    height: 90 / @rem;
  }
  .stamp-item-num {
    width: 90 / @rem;
    height: 90 / @rem;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -45 / @rem;
    margin-top: -48 / @rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'PingFang HK';
    font-style: normal;
    font-weight: 400;
    font-size: 36 / @rem;
    line-height: 36 / @rem;
    text-align: center;
    color: rgba(128, 128, 128, 0.3);
  }
}
</style>
